// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1t0Zi","inner":"Footer_inner__1E7yp","nextIcon":"Footer_nextIcon__EM_--","innerLeft":"Footer_innerLeft__1N1_I"};